(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["piou-gift-stock-v866"] && !Shopify.designMode) return;
  try {
    const initGiftStockCounters = (root = document) => {
    root.querySelectorAll('[data-gift-stock-counter]').forEach((counter) => {
      if (counter.dataset.giftStockReady === 'true') return;

      const countNode = counter.querySelector('[data-gift-stock-count]');
      const barNode = counter.querySelector('[data-gift-stock-bar]');
      const initial = Number.parseInt(counter.dataset.giftStockInitial || '27', 10);
      const total = Number.parseInt(counter.dataset.giftStockTotal || '1000', 10);
      const interval = Number.parseInt(counter.dataset.giftStockInterval || '15000', 10);

      if (!countNode || !barNode || !Number.isFinite(initial) || initial < 0 || !Number.isFinite(total) || total <= 0 || initial > total || !Number.isFinite(interval) || interval < 1000) return;

      let remaining = initial;
      counter.dataset.giftStockReady = 'true';

      const render = () => {
        countNode.textContent = `${remaining}/${total}`;
        const percentage = Math.max(0, Math.min(100, (remaining / total) * 100));
        barNode.style.width = `${percentage}%`;
      };

      render();
      window.setInterval(() => {
        if (remaining <= 0) return;
        remaining -= 1;
        render();
      }, interval);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initGiftStockCounters(), { once: true });
  } else {
    initGiftStockCounters();
  }

  document.addEventListener('shopify:section:load', (event) => initGiftStockCounters(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-stories"] && !Shopify.designMode) return;
  try {
    (function(){
  var ROOT='[data-piou-video-carousel]';
  var muteOthers=function(active){
    document.querySelectorAll(ROOT+' video').forEach(function(video){
      if(video===active)return;
      video.muted=true;
      video.defaultMuted=true;
      video.setAttribute('muted','');
      var card=video.closest('[data-piou-video-card]');
      var button=card&&card.querySelector('[data-piou-video-sound]');
      if(button){button.setAttribute('aria-pressed','false');button.setAttribute('aria-label',button.dataset.labelOn||'Activer le son');}
    });
  };
  var requestFull=function(video){
    if(typeof video.webkitEnterFullscreen==='function'){try{video.webkitEnterFullscreen();return;}catch(error){}}
    if(typeof video.requestFullscreen==='function'){video.requestFullscreen().catch(function(){});return;}
    if(video.parentElement&&typeof video.parentElement.requestFullscreen==='function'){video.parentElement.requestFullscreen().catch(function(){});}
  };
  var init=function(root){
    (root||document).querySelectorAll(ROOT).forEach(function(section){
      if(section.dataset.piouCarouselReady==='true')return;
      section.dataset.piouCarouselReady='true';
      var rail=section.querySelector('[data-piou-video-rail]');
      var cards=Array.from(section.querySelectorAll('[data-piou-video-card]'));
      var dots=Array.from(section.querySelectorAll('.piou-video-stories-v889__nav span'));
      cards.forEach(function(card){
        var video=card.querySelector('video');
        var sound=card.querySelector('[data-piou-video-sound]');
        var expand=card.querySelector('[data-piou-video-expand]');
        var playButton=card.querySelector('[data-piou-video-play]');
        if(!video)return;
        video.muted=true;video.defaultMuted=true;video.loop=true;video.playsInline=true;
        video.setAttribute('muted','');video.setAttribute('loop','');video.setAttribute('playsinline','');video.setAttribute('webkit-playsinline','');
        var syncPlayButton=function(){if(playButton){playButton.classList.toggle('is-hidden',!video.paused);}};
        var play=function(){var p=video.play();if(p&&typeof p.catch==='function')p.catch(function(){});};
        video.addEventListener('playing',syncPlayButton);
        video.addEventListener('pause',syncPlayButton);
        video.addEventListener('ended',syncPlayButton);
        syncPlayButton();
        if('IntersectionObserver' in window){var p9io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){if(video.dataset.poster){video.setAttribute('poster',video.dataset.poster);video.removeAttribute('data-poster');}if(video.preload==='none')video.preload='auto';video.autoplay=true;video.setAttribute('autoplay','');play();if(!video.dataset.p9Can){video.dataset.p9Can='1';video.addEventListener('canplay',function(){if(video.paused&&video.dataset.p9Off!=='1')play();});}video.dataset.p9Off='0';}else{video.dataset.p9Off='1';if(!video.paused){video.pause();}}});},{rootMargin:'300px 0px'});p9io.observe(card);}else{play();}
        if(sound){sound.addEventListener('click',function(){var on=video.muted;if(on){muteOthers(video);video.muted=false;video.defaultMuted=false;video.removeAttribute('muted');sound.setAttribute('aria-pressed','true');sound.setAttribute('aria-label',sound.dataset.labelOff||'Couper le son');play();}else{video.muted=true;video.defaultMuted=true;video.setAttribute('muted','');sound.setAttribute('aria-pressed','false');sound.setAttribute('aria-label',sound.dataset.labelOn||'Activer le son');}});}
        if(playButton){playButton.addEventListener('click',function(){muteOthers(video);video.muted=false;video.defaultMuted=false;video.removeAttribute('muted');if(sound){sound.setAttribute('aria-pressed','true');sound.setAttribute('aria-label',sound.dataset.labelOff||'Couper le son');}play();});}
        if(expand){expand.addEventListener('click',function(){play();requestFull(video);});}
      });
      var productSection=section.closest('[data-product-section]');
      var packPicker=productSection&&productSection.querySelector('.pack-picker');
      if(packPicker&&section.parentElement!==packPicker.parentElement){
        packPicker.parentElement.insertBefore(section,packPicker);
      }else if(packPicker&&section.nextElementSibling!==packPicker){
        packPicker.parentElement.insertBefore(section,packPicker);
      }
      var prev=section.querySelector('[data-piou-video-prev]');
      var next=section.querySelector('[data-piou-video-next]');
      if(rail&&cards.length){
        var step=function(){return (cards[0]&&cards[0].getBoundingClientRect().width||240)+12;};
        if(prev){prev.addEventListener('click',function(){rail.scrollBy({left:-step(),behavior:'smooth'});});}
        if(next){next.addEventListener('click',function(){rail.scrollBy({left:step(),behavior:'smooth'});});}
      }
      if(rail&&cards.length&&dots.length){
        var update=function(){var left=rail.scrollLeft;var best=0;var distance=Infinity;cards.forEach(function(card,index){var d=Math.abs(card.offsetLeft-rail.offsetLeft-left);if(d<distance){distance=d;best=index;}});dots.forEach(function(dot,index){dot.classList.toggle('is-active',index===best);});};
        rail.addEventListener('scroll',function(){window.requestAnimationFrame(update);},{passive:true});
        update();
      }
    });
  };
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){init(document);},{once:true});}else{init(document);}
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();
  } catch(e) { console.error(e); }
})();

})();
